// extracted by mini-css-extract-plugin
module.exports = {"featureSet":"_9bc32__index-module__feature-set","feature":"_3a475__index-module__feature"};